import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { Document, CommonService, DocumentContext, SaveDocument, GetDocuments, Time } from 'huddyapi';


@Component({
  selector: 'edit-document-dialog',
  templateUrl: 'edit-document-dialog.component.html',
  styleUrls: ["./edit-document-dialog.component.scss"]
})
export class EditDocumentDialog  {
  

  edited : Document;
  contextId : number;
  contextType : string;
  library : Document[];
  libraryId : number;
  note : boolean;

  documentForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(512)]],
    description:  ['', [Validators.required, Validators.maxLength(1024)]],
    authors:  ['', [Validators.required, Validators.maxLength(512)]],
    url:  ['', [Validators.required, Validators.maxLength(1024)]],
    note: []
});

  constructor(
    public dialogRef: MatDialogRef<EditDocumentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    private common : CommonService,
    public store : Store
  )
  {
    console.log('data', data);
    if (data.library) {
      this.library = [].concat(data.library);
    }

    this.setForm(data);

    if (this.edited.contexts && this.edited.contexts.length > 0) {
      this.contextId = this.edited.contexts[0].contextId;
      this.contextType = this.edited.contexts[0].contextType;
    }

  }

  ngOnInit(): void {
   console.log(this.edited);
  }

  isFormInValid() {
    return (this.documentForm.invalid);
  }

  onSubmitForm(treatmentForm) {
   this.save();
  }

  close() {
     
      this.dialogRef.close();
  }

  save() {
     let context : DocumentContext[] = (this.edited.contexts) ? this.edited.contexts :
      [];
     context.push(new DocumentContext({
      documentReferenceId : this.edited.id,
      contextId : this.contextId,
      contextType : this.contextType
   }));  
      
      let g : Document = new Document({
        id: (this.edited.id && this.edited.id > -1) ? this.edited.id : null,
        name : this.documentForm.value.name,
        description :  this.documentForm.value.description,
        authors : this.documentForm.value.authors, 
        url : this.documentForm.value.url,
        contexts : context
      });
    console.log('Document to save', g);  
    this.store.dispatch(new SaveDocument(g, this.contextType, this.contextId)).subscribe(t => {
          this.store.dispatch(new GetDocuments(this.contextType, this.contextId, undefined, undefined, undefined));
          this.close();
        });
  }

  onSelectFromLibrary(libraryId : number) {
    console.log('onSelectFromLibrary', libraryId, this.libraryId);
    let document : Document = this.library.find(d => d.id === libraryId);
    console.log('onSelectFromLibrary', document);
    this.setForm(document);
  }

  toggleNote(isNote : boolean) {
    if (isNote) {
      this.documentForm.patchValue({
        url: 'note://',
        authors: CommonService.currentUserToView,
        name : 'Note ' + new Time().getDateDisplay()
      });
    } else {
      this.documentForm.patchValue({
        url: '',
        name : ''
      });
    }
  }

  isNote() {
    return this.documentForm.value.url === 'note://';
  }

  setForm(data : any) {

    this.edited = new Document({
      id : data.id,
      name: data.name ?? '', 
      description: data.description ?? '',
      authors : data.authors ?? [],
      url : data.url ?? [],
      contexts : data.contexts ?? []
    });

    this.documentForm.setValue({
      name: data.name ?? '',
      description: data.description ?? '',
      authors: data.authors ?? '',
      url: data.url ?? '',
      note: data.url === 'note://'
    });
   
  }

}

export interface PractitionerGroup {
  id : number;
  name: string;
  description: string;
  users: string[];
}